/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react'
import CommentForm from 'flow/SiteProposal/components/Comments/CommentForm'
import CommentsList from 'flow/SiteProposal/components/Comments/CommentsList'
import { SiteContext } from 'providers/site'
import { requestCommentsData } from 'api/site'
import { useParams } from 'react-router-dom'
import LoadingWrapper from 'components/LoadingWrapper'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { editOnly } from 'routing/constants'

const CommentSection = ({ setCommentsNumber }) => {
  const params = useParams()
  const [comments, setComments] = useState([])
  const [filteredComments, setFilteredComments] = useState([])
  const [categorySelected, setCategorySelected] = useState({ value: null, label: 'Select a category' })
  const [isLoading, setIsLoading] = useState(false)
  const { site } = useContext(SiteContext)

  const editOnlySite = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null;
  const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  const historyId = editOnlySiteStatus ? site.sitehistoryId : params.siteHistoryId

  const getCommentsData = async () => {
    setIsLoading(true);
    try {
      const data = await requestCommentsData(site.id, historyId, editOnlySite);
      if (data.error) return;
      setComments(data);
      setCommentsNumber(data.length);

      if (categorySelected.value) {
        const filtered = data.filter(item => {
          return item.CommentCategory.id === categorySelected.value;
        });
        setFilteredComments(filtered);
      } else {
        setFilteredComments(data);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const changeCategory = (id) => {
    if (id === null) {
      return setFilteredComments(comments)
    }
    return setFilteredComments(() => {
      return comments.filter((item) => {
        return item.CommentCategory.id === id
      })
    })
  }

  useEffect(() => {
    getCommentsData()
  }, [])

  return (
    <>
      <CommentForm changeCategory={changeCategory} getCommentsData={getCommentsData} categorySelected={categorySelected} setCategorySelected={setCategorySelected} />
      <LoadingWrapper size={'24px'} isLoading={isLoading}>
        <CommentsList getCommentsData={getCommentsData} commentData={filteredComments} />
      </LoadingWrapper>
    </>
  )
}

export default CommentSection
